module.exports = __webpack_public_path__ + "img/harriet-beecher-stowe.7280a9fe.png";